import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import {
  CognitoUser,
  CognitoUserPool
} from 'amazon-cognito-identity-js';
import FormForgotPasswordView from './FormForgotPassword-view';
import {checkRequiredValues} from 'common/utils/form/checkRequiredValues';

import cognitoConfig from 'config/cognito';
const { PoolData } = cognitoConfig;

const FormForgotPassword = ({goNext, contextActions, messagePopup, showMessage}) => {
  const initialValues = {
    username: ''
  };

  const validate = values => {
    return checkRequiredValues(values, {});
  };

  const handleSubmit = values => {
    const userPool = new CognitoUserPool(PoolData);
    const userData = {
      Username: values.username,
      Pool: userPool,
    };
    const cognitoUser = new CognitoUser(userData);
    cognitoUser.forgotPassword({
      onSuccess: function (data) {
        contextActions.pushStepContext({cognitoUser});
        goNext();
      },
      onFailure: function (err) {
        showMessage(err.message || JSON.stringify(err));
        console.error(err);
      },
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <>
          <FormForgotPasswordView
            {...formikProps}
          />
          {messagePopup}
        </>
      )}
    </Formik>
  )
};

FormForgotPassword.propTypes = {
  goNext: PropTypes.func,
  contextActions: PropTypes.object,
};

export default FormForgotPassword;
